// src/pages/Landing.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactCompareImage from 'react-compare-image'; // Asegúrate que esté instalado e importado
import { ArrowRight, Home, Camera, MessageSquare, CreditCard, UploadCloud, Sparkles, Clock } from 'lucide-react'; // Eliminé X porque no se usaba
import AuthModal from '../components/AuthModal';


import imgOriginal from '../assets/images/original.png'; // <-- CAMBIO
import imgDesigned from '../assets/images/cambiada.png'; // <-- CAMBIO


const Landing = () => {
  // --- Estados y Efectos ---
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState('visual');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 100);
    const handleMouseMove = (e) => {
        setMousePosition({
          x: (e.clientX / window.innerWidth) - 0.5,
          y: (e.clientY / window.innerHeight) - 0.5
        });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // --- Funciones Handler para el Modal ---
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleLoginSuccess = (token) => {
    console.log("Login successful, token:", token);
    localStorage.setItem('access_token', token);
    handleCloseModal();
    navigate('/DesignStudio');
  };
  const handleRegisterSuccess = () => {
    console.log("Registration successful");
    // Podrías querer cambiar a la pestaña de Login o mostrar un mensaje aquí
  };

  // --- Datos para Características/Beneficios ---
  const features = [
    { icon: <UploadCloud size={20} />, title: "Empieza Fácil", desc: "Solo necesitas una foto de tu espacio." },
    { icon: <Sparkles size={20} />, title: "IA Personalizada", desc: "Recibe ideas adaptadas a tus gustos." },
    { icon: <Home size={20} />, title: "Compra con Confianza", desc: "Todos los muebles sugeridos son reales." },
    { icon: <Clock size={20} />, title: "Ahorra Tiempo", desc: "Encuentra lo que buscas rápidamente." }
  ];

  // --- URLs de imágenes placeholder (Usando picsum.photos para prueba) ---
  const placeholderOriginal = imgOriginal;
  const placeholderDesigned = imgDesigned;
  const placeholderSofa = "https://picsum.photos/seed/sofa/40/40";          // <-- CAMBIO: Usando picsum.photos
  const placeholderLamp = "https://picsum.photos/seed/lamp/40/40";          // <-- CAMBIO: Usando picsum.photos

  return (
    <>
      <div className="relative min-h-screen w-full overflow-hidden bg-slate-950 flex items-center justify-center px-4 text-white"> {/* Añadido text-white globalmente */}
        {/* --- Elementos de fondo y malla --- */}
        <div className="absolute top-0 right-0 w-3/4 h-3/4 rounded-full filter blur-3xl opacity-40" style={{ background: 'linear-gradient(135deg, rgba(123, 31, 162, 0.5), rgba(103, 58, 183, 0.3), rgba(233, 30, 99, 0.5))', transform: `translate(${mousePosition.x * -30}px, ${mousePosition.y * -30}px)`, transition: 'transform 0.3s ease' }} />
        <div className="absolute bottom-0 left-0 w-3/4 h-3/4 rounded-full filter blur-3xl opacity-30" style={{ background: 'linear-gradient(215deg, rgba(32, 149, 242, 0.5), rgba(94, 53, 177, 0.3), rgba(139, 195, 74, 0.4))', transform: `translate(${mousePosition.x * -20}px, ${mousePosition.y * -20}px)`, transition: 'transform 0.3s ease' }} />
        <div className="absolute inset-0" style={{ backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px)`, backgroundSize: '30px 30px', backgroundPosition: `${mousePosition.x * 5}px ${mousePosition.y * 5}px`, transition: 'background-position 0.3s ease' }} />
        <div className={`absolute w-64 h-64 rounded-full border border-purple-500/30 opacity-70 ${isLoaded ? 'scale-100' : 'scale-0'}`} style={{ transform: `translate(${mousePosition.x * -50}px, ${mousePosition.y * -40}px) rotate(${mousePosition.x * 30}deg)`, top: '20%', right: '10%', transition: 'transform 0.4s ease, scale 1.5s ease' }} />
        <div className={`absolute w-40 h-40 rounded-xl bg-gradient-to-r from-purple-600/20 to-pink-600/20 backdrop-blur-sm opacity-80 ${isLoaded ? 'scale-100' : 'scale-0'}`} style={{ transform: `translate(${mousePosition.x * -20}px, ${mousePosition.y * -20}px) rotate(${mousePosition.y * 20}deg)`, right: '30%', top: '35%', boxShadow: '0 0 30px rgba(147, 51, 234, 0.2), inset 0 0 20px rgba(236, 72, 153, 0.2)', transition: 'transform 0.3s ease, scale 1s ease' }} />

        {/* --- Contenido principal --- */}
        <div className={`relative z-10 max-w-6xl mx-auto py-12 transition-opacity duration-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">

            {/* === Columna de texto === */}
            <div className="lg:col-span-6 space-y-8">
              {/* --- 1. Título (CORREGIDO para 3 líneas) --- */}
              <h1 className="text-5xl lg:text-7xl font-extrabold">
                {/* Línea 1 */}
                <span className="block bg-clip-text text-transparent bg-gradient-to-r from-white via-purple-200 to-cyan-200">
                  Transforma tu
                </span>
                {/* Línea 2 */}
                <span className="block mt-1 text-white"> {/* Ajuste ligero de margen si es necesario */}
                  hogar con <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">IA</span>
                </span>
                {/* Línea 3 */}
                <span className="block text-white">
                  y muebles <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">reales</span>
                </span>
              </h1>

              {/* 2. Botón Principal Único */}
              <div className="flex">
                <button
                  onClick={handleOpenModal}
                  className="group px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg text-white font-bold text-lg relative overflow-hidden transition-transform transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-950 focus:ring-purple-500"
                >
                  <span className="relative z-10 flex items-center justify-center">
                    Probar ahora
                    <ArrowRight size={20} className="ml-2 transition-transform group-hover:translate-x-1" />
                  </span>
                  <span className="absolute inset-0 bg-gradient-to-r from-purple-700 to-pink-700 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
                </button>
              </div>
              {/* 3. Párrafo */}
              <p className="text-xl text-gray-300 max-w-xl leading-relaxed">
                Sube una foto de tu espacio, describe tu estilo y nuestra IA generará un rediseño visual usando muebles que puedes comprar.
              </p>
              {/* 4. Badge */}
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-purple-900/30 backdrop-blur-md border border-purple-500/20 text-purple-300 text-sm font-medium">
                <Camera size={14} className="mr-2" />
                <span>Muebles reales, diseños virtuales</span>
              </div>
              {/* 5. Comparación de Planes */}
              <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-4 flex flex-col sm:flex-row gap-4">
                 <div className="flex-1 flex items-center py-1 px-2 bg-purple-600/20 border border-purple-500/30 rounded-lg">
                   <MessageSquare size={20} className="text-purple-400 mr-2 flex-shrink-0" /> {/* Añadido flex-shrink-0 */}
                   <div>
                     <span className="block text-sm font-medium text-white">Plan Gratuito</span>
                     <span className="text-xs text-gray-400">Chat + Lista de productos</span>
                   </div>
                 </div>
                 <div className="flex-1 flex items-center py-1 px-2 bg-gradient-to-r from-purple-600/20 to-pink-600/20 border border-purple-500/30 rounded-lg">
                   <CreditCard size={20} className="text-pink-400 mr-2 flex-shrink-0" /> {/* Añadido flex-shrink-0 */}
                   <div>
                     <span className="block text-sm font-medium text-white">Plan Premium</span>
                     <span className="text-xs text-gray-400">Generación visual IA</span>
                   </div>
                 </div>
              </div>
            </div>
            {/* === Fin Columna de texto === */}

            {/* === Columna de demostración === */}
            <div className="lg:col-span-6 relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-purple-600/40 to-pink-600/40 rounded-2xl blur-2xl opacity-30 -m-4"></div>
              <div className="relative bg-gray-900 border border-gray-800 rounded-2xl overflow-hidden shadow-2xl">
                 {/* Barra y Tabs */}
                 <div className="h-8 bg-gray-800 flex items-center justify-between px-4 border-b border-gray-700"> {/* Ligero cambio de color para contraste */}
                    <div className="flex space-x-2">
                       <div className="w-3 h-3 rounded-full bg-red-500"></div>
                       <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                       <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    </div>
                    <div className="text-xs text-gray-400">HomzyAI.com</div> {/* Ajuste de color */}
                    <div className="w-12"></div> {/* Ajuste para centrar mejor */}
                 </div>
                 <div className="flex bg-gray-950 border-b border-gray-800">
                    <button
                       className={`flex-1 py-3 text-sm font-medium text-center transition-colors duration-200 ${activeTab === 'visual' ? 'text-purple-400 border-b-2 border-purple-500' : 'text-gray-400 hover:text-gray-200'}`}
                       onClick={() => setActiveTab('visual')}
                    >
                       Transformación Visual
                    </button>
                    <button
                       className={`flex-1 py-3 text-sm font-medium text-center transition-colors duration-200 ${activeTab === 'chat' ? 'text-purple-400 border-b-2 border-purple-500' : 'text-gray-400 hover:text-gray-200'}`}
                       onClick={() => setActiveTab('chat')}
                    >
                       Chat de Productos
                    </button>
                 </div>
                 {/* Contenido Demo */}
                 <div className="p-4 min-h-[400px] sm:min-h-[450px] bg-gray-950"> {/* Fondo consistente */}
                   {activeTab === 'visual' ? (
                      <>
                        <div className="mb-4 bg-gray-900 p-3 rounded-lg border border-gray-800 flex items-center justify-between"> {/* Fondo un poco más claro */}
                           <div className="flex items-center">
                             <UploadCloud size={18} className="text-purple-400 mr-2" />
                             <span className="text-sm font-medium text-white">Tu Espacio</span>
                           </div>
                           {/* Podrías añadir un botón de 'Cambiar foto' aquí si quisieras */}
                        </div>
                        {/* --- ÁREA DEL COMPARADOR --- */}
                        <div className="aspect-video rounded-lg overflow-hidden border border-gray-700 bg-gray-800 flex items-center justify-center text-white"> {/* Centrado si la imagen falla */}
                           <ReactCompareImage
                              leftImage={placeholderOriginal}
                              rightImage={placeholderDesigned}
                              // Añadir alt text por accesibilidad
                              leftImageAlt="Espacio original"
                              rightImageAlt="Espacio rediseñado con IA"
                           />
                           {/* Mensaje de error de Google Client ID */}
                           {!process.env.REACT_APP_GOOGLE_CLIENT_ID && (
                             <div className="absolute inset-0 flex items-center justify-center bg-red-900/80">
                               <p className="text-red-200 p-4 text-xs font-semibold">Error: Falta REACT_APP_GOOGLE_CLIENT_ID en .env</p>
                             </div>
                           )}
                        </div>
                        {/* --- Fin Área Comparador --- */}
                        <div className="mt-3 p-2 bg-gray-900 rounded-lg text-center border border-gray-800"> {/* Borde añadido */}
                           <div className="text-xs text-gray-400">Descripción Usada:</div>
                           <div className="text-sm text-white font-medium">"Salón moderno y luminoso"</div>
                        </div>
                        <div className="mt-4 p-3 bg-gray-900 rounded-lg border border-gray-800"> {/* Fondo un poco más claro */}
                            <div className="text-sm font-medium text-white mb-2 flex justify-between items-center">
                               <span>Productos Sugeridos</span>
                               {/* Este botón podría llevar a una vista detallada o modal */}
                               <button className="text-xs text-purple-400 hover:text-purple-300 hover:underline focus:outline-none">
                                 Ver Todos
                               </button>
                            </div>
                            <div className="space-y-2">
                               <div className="flex items-center p-2 bg-gray-800/50 rounded-md"> {/* Fondo sutil para cada item */}
                                 <img src={placeholderSofa} alt="Sofá" className="w-8 h-8 rounded-md mr-2 flex-shrink-0"/>
                                 <div className="flex-1">
                                   <div className="text-xs text-white truncate"> Test producto 1 </div> {/* Truncate si es largo */}
                                   <div className="text-xs text-gray-400">799€</div>
                                 </div>
                                 <button className="ml-2 text-xs text-purple-400 hover:text-purple-300 hover:underline focus:outline-none">
                                   Ver
                                 </button>
                               </div>
                               <div className="flex items-center p-2 bg-gray-800/50 rounded-md"> {/* Fondo sutil para cada item */}
                                 <img src={placeholderLamp} alt="Lámpara" className="w-8 h-8 rounded-md mr-2 flex-shrink-0"/>
                                 <div className="flex-1">
                                   <div className="text-xs text-white truncate"> Test producto 2 </div> {/* Truncate si es largo */}
                                   <div className="text-xs text-gray-400">149€</div>
                                 </div>
                                 <button className="ml-2 text-xs text-purple-400 hover:text-purple-300 hover:underline focus:outline-none">
                                   Ver
                                 </button>
                               </div>
                            </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Contenido Chat Demo */}
                        <div className="bg-gray-900 rounded-lg border border-gray-800 h-full flex flex-col"> {/* Fondo un poco más claro */}
                          <div className="flex-1 space-y-4 overflow-y-auto p-3 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-800/50">
                            {/* Mensaje AI */}
                            <div className="flex">
                              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center text-white text-xs mr-2 font-medium">AI</div>
                              <div className="max-w-[80%] bg-gray-800 rounded-lg p-3 text-sm text-gray-200 break-words shadow-md">
                                ¿Qué estilo te gustaría explorar hoy?
                              </div>
                            </div>
                            {/* Mensaje Usuario */}
                            <div className="flex justify-end">
                              <div className="max-w-[80%] bg-purple-700/50 border border-purple-600/50 rounded-lg p-3 text-sm text-gray-200 break-words shadow-md">
                                Un estilo moderno para mi salón.
                              </div>
                            </div>
                            {/* Mensaje AI */}
                            <div className="flex">
                              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center text-white text-xs mr-2 font-medium">AI</div>
                              <div className="max-w-[80%] bg-gray-800 rounded-lg p-3 text-sm text-gray-200 break-words shadow-md">
                                ¡Perfecto! Para un look moderno para tu salón, te recomiendo estas piezas: [Lista de productos...]
                                {/* Aquí podrías simular mostrar algunos productos */}
                              </div>
                            </div>
                          </div>
                          {/* Input de Chat */}
                          <div className="p-3 border-t border-gray-700">
                            <div className="relative">
                              <input
                                type="text"
                                placeholder="Escribe tu mensaje..."
                                className="w-full bg-gray-800 border border-gray-700 rounded-lg py-2 pl-4 pr-10 text-white text-sm focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500 placeholder-gray-500"
                              />
                              <button className="absolute right-2 top-1/2 transform -translate-y-1/2 text-purple-400 hover:text-purple-300 p-1 rounded-full focus:outline-none focus:ring-1 focus:ring-purple-500">
                                <ArrowRight size={18} />
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                 </div>
                 {/* Elementos decorativos */}
                 <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl opacity-40 blur-xl pointer-events-none"></div> {/* Ajuste Opacidad y pointer-events */}
                 <div className="absolute -top-4 -left-4 w-32 h-32 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full opacity-20 blur-2xl pointer-events-none"></div> {/* Ajuste Opacidad y pointer-events */}
              </div>
              {/* === Fin Interfaz de aplicación simulada === */}
            </div>
            {/* === Fin Columna de demostración === */}

          </div> {/* Fin Grid principal */}

          {/* === Sección de Características/Beneficios === */}
          <section className="mt-16 sm:mt-24 pt-12 border-t border-gray-800/50"> {/* Más padding top */}
             <h2 className="text-3xl sm:text-4xl font-bold text-center text-white mb-10 sm:mb-14"> {/* Tamaño y margen ajustados */}
                Diseña sin Límites
             </h2>
             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8"> {/* Gap ajustado */}
                {features.map((feature, idx) => (
                   <div key={idx} className="p-6 rounded-xl bg-gray-900/60 border border-gray-800/70 backdrop-blur-sm text-center sm:text-left shadow-lg transition-transform transform hover:-translate-y-1 hover:shadow-purple-500/10"> {/* Efecto hover sutil */}
                      <div className="inline-flex sm:flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-purple-600 to-pink-600 text-white mb-4 shadow-md">
                         {feature.icon}
                      </div>
                      <h3 className="text-lg font-semibold text-white mb-2">{feature.title}</h3> {/* Margen ajustado */}
                      <p className="text-sm text-gray-400 leading-relaxed">{feature.desc}</p> {/* Leading ajustado */}
                   </div>
                ))}
             </div>
          </section>
          {/* === Fin Sección de Características === */}

        </div> {/* Fin Contenido principal (contenedor z-10) */}
      </div> {/* Fin Contenedor principal de la pantalla */}

      {/* Renderizado condicional del Modal */}
      {isModalOpen && (
        <AuthModal
          onClose={handleCloseModal}
          onLoginSuccess={handleLoginSuccess}
          onRegisterSuccess={handleRegisterSuccess}
        />
      )}
    </>
  );
};

export default Landing;